import { useEffect } from 'react'

export const useNotificationBootstrap = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return
    let cancelled = false

    queueMicrotask(() => {
      if (cancelled) return
      void import('../utils/initializeNotifications')
        .then(({ initializeNotifications }) => {
          if (!cancelled) return initializeNotifications()
        })
        .catch(() => {
          if (!cancelled) {
            console.warn(
              'Notification setup failed. Check Firebase configuration, browser storage, and service-worker registration.',
            )
          }
        })
    })

    return () => {
      cancelled = true
    }
  }, [enabled])
}
